export const addApiUrlToLocalStorage = () => {
  if (window.location.hostname === "localhost") {
    // localStorage.setItem(
    //   "apiUrl",
    //   // "http://localhost/Delsa/Frm"
    //   // "http://localhost/Git/Delsa/Frm"
    //   // "http://localhost/Saden/Frm"
    //   // "http://localhost/Git/niko/Frm"
    //   // "https://admin.nikogolestan.ir/Frm"
    //   // "https://admin.nikogolestan.ir/Frm/",
    //   // "https://autoc.varkan.ir/Frm"
    //   // "https://sajadcameron.ravanhesab.com/Frm"
    //   // "https://test.ravanhesab.com/Frm"
    //   // "https://testcarwash.ravanhesab.com/Frm"
    //   // "http://localhost/Delsa/Frm"
    //   "https://testsadanshop.ravanhesab.com/Frm"
    // );


    localStorage.setItem("apiUrl" , process.env.REACT_APP_URL)
  } else {
    localStorage.setItem("apiUrl", "/Frm");
  }
};

export const prefixUrl = () => {
  if (
    localStorage.getItem("apiUrl") === null ||
    localStorage.getItem("apiUrl") === undefined
  ) {
    addApiUrlToLocalStorage();
  }
  return localStorage.getItem("apiUrl");
};
